import { Row, Typography } from "antd";
import { useEffect } from "react";
import { useParams, Navigate } from "react-router-dom";
import HomePageNavbarComponent from "../../../components/HomePageNavbarComponent/HomePageNavbarComponent";
import Footer from "../../../components/HomePageFooter/HomePageFooter";
import { getBlogBySlug } from "../../../data/blog-articles";
import "./BlogArticlePage.less";
import { Helmet } from "react-helmet-async";

const BlogArticlePage = () => {
  const { slug } = useParams<{ slug: string }>();
  const article = slug ? getBlogBySlug(slug) : undefined;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!article) {
    return <Navigate to="/blogs" replace />;
  }

  return (
    <>
      <Helmet>
        <title>{article.title} | Twizz Blog</title>
        <meta name="description" content={article.metaDescription} />
        <meta property="og:title" content={article.title} />
        <meta property="og:description" content={article.metaDescription} />
        <meta property="og:type" content="article" />
        <meta property="og:url" content={`https://www.twizz.com/blogs/${article.slug}`} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={article.title} />
        <meta name="twitter:description" content={article.metaDescription} />
        <link rel="canonical" href={`https://www.twizz.com/blogs/${article.slug}`} />
      </Helmet>

      <div className="blog-article-wrapper">
        <HomePageNavbarComponent />

        <div className="blog-article-layout">
          <Row className="article-content-row">
            <div className="article-header">
              <div className="article-category">{article.category}</div>
            </div>

            <div className="article-content">{article.content}</div>
          </Row>
        </div>
        <Footer hideElement={["blog"]} hideFooter={true} />
        {/* SEO: Link for crawlers */}
        <details>
          <summary style={{ listStyle: "none" }}></summary>
          <a href="/profiles">Creator Profiles</a>
        </details>
      </div>
    </>
  );
};

export default BlogArticlePage;
